import { ref } from 'vue';
import videojs from 'video.js';
import '../styles/overlay.css';

export function useOverlay() {
  const overlay = ref(null);
  const OVERLAY_DURATION = 2500;

  function showOverlay(player, message) {
    if (!player) return;

    const OverlayComponent = videojs.getComponent('Component');

    if (overlay.value) {
      player.removeChild(overlay.value);
    }

    overlay.value = new OverlayComponent(player, {
      el: videojs.dom.createEl('div', {
        innerHTML: `
          <div class="vjs-custom-overlay">
            <div class="progress-bg">
              <div class="progress-fill"></div>
            </div>
            <p>Next episode: </p>
            <p class="title-text">${message}</p>
          </div>
        `,
        className: 'vjs-custom-overlay-container'
      })
    });

    player.addChild(overlay.value);

    setTimeout(() => {
      if (overlay.value) {
        player.removeChild(overlay.value);
        overlay.value = null;
      }
    }, OVERLAY_DURATION);
  }

  return { showOverlay };
}
